<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";
import { isActionVisible, isStickyMovable } from "@/components/utils/actions";
import { injectStrict } from "@/utils/vue";

import MoveSticky from "./MoveSticky.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => {
  const isVisible = isActionVisible("move", card, board.value);
  const isMovable = isStickyMovable(card, board.value);

  return isVisible && isMovable;
});
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.move">
    <MoveSticky />
  </ActionMenuDropdown>
</template>
